export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Profile-Appearance-Gray-7f2ac37235bb4d447a2f7c9f00622e3e.svg";